import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Card, CardTitle, Text } from '@reveni-io/reveni-ui'

import Statistic from '@/common/components/Statistic/Statistic'
import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'

import * as Styles from './styles'

const YourNumbersCardSkeleton = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Card>
      <CardTitle marginBottom={theme.spacing.sp16}>{t('Tus números')}</CardTitle>
      <Styles.Content>
        <StatisticGroup>
          <Statistic isOutlined={false} caption loading />
          <Statistic isOutlined={false} caption loading />
          <Statistic isOutlined={false} caption loading />
          <Statistic isOutlined={false} caption loading />
        </StatisticGroup>
        <Text type="allCapsM" color={theme.colors.text.subtle}>
          {t('Por vista')}
        </Text>
        <StatisticGroup>
          <Statistic isOutlined={false} caption loading />
          <Statistic isOutlined={false} caption loading />
          <Statistic isOutlined={false} caption loading />
        </StatisticGroup>
      </Styles.Content>
    </Card>
  )
}

export default YourNumbersCardSkeleton
